import React from "react";
import { Helmet } from "react-helmet-async";

export default function JsonLd({ data }) {
  const list = Array.isArray(data) ? data : [data];
  return (
    <Helmet>
      {list.map((d, i) => (
        <script key={i} type="application/ld+json">{JSON.stringify(d)}</script>
      ))}
    </Helmet>
  );
}
